import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import H4 from 'UIComponents/elements/headings/H4';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject'; // @ts-expect-error svg import

import BLOB from 'bender-url!pricing-pages-ui/img/splash-page/suite-card-top-right-blob.svg';
import { getTrialUpgradeData } from 'pricing-pages-lib/utils/ebx642Utils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import UITrialActivationButton from 'ui-addon-upgrades/button/UITrialActivationButton';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { APP, SCREENS } from '../../constants/tracking/Locations';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
export const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "Ebx642CompareProCard__StyledCardWrapper",
  componentId: "sc-5drcxf-0"
})(["padding:48px 24px 24px 24px;margin-bottom:16px;"]);
export const StyledBlob = styled(UIImage).withConfig({
  displayName: "Ebx642CompareProCard__StyledBlob",
  componentId: "sc-5drcxf-1"
})(["position:absolute;top:0;right:0;width:180px;"]);
const Title = styled(H4).withConfig({
  displayName: "Ebx642CompareProCard__Title",
  componentId: "sc-5drcxf-2"
})(["z-index:1;position:relative;"]);
const Container = styled.div.withConfig({
  displayName: "Ebx642CompareProCard__Container",
  componentId: "sc-5drcxf-3"
})(["max-width:402px;"]);

const EBX642CompareProCard = ({
  productLevel,
  productLine
}) => {
  const productLineFormatted = productLine.toLowerCase();
  useEffect(() => {
    getUsageTracker().track('proCompareToolInteraction', {
      action: 'viewed view pricing button',
      productLevel,
      productLine,
      domain: 'ebx-642'
    });
  }, [productLevel, productLine]);

  const onCTAClick = action => {
    getUsageTracker().track('proCompareToolInteraction', {
      action,
      productLevel,
      productLine,
      domain: 'ebx-642'
    });
  };

  const UPGRADE_DATA = getTrialUpgradeData({
    app: APP,
    screen: SCREENS.COMPARE_PROFESSIONAL,
    productLine
  });

  const MarketingProCTAs = () => {
    return /*#__PURE__*/_jsxs(UIButtonGroup, {
      className: 'm-top-4',
      orientation: "vertical",
      style: {
        display: 'flex'
      },
      children: [/*#__PURE__*/_jsx(UITrialActivationButton, {
        upgradeData: UPGRADE_DATA,
        block: true,
        use: "primary",
        style: {
          borderRadius: '3px'
        },
        onClick: () => onCTAClick('clicked trial activation button')
      }), /*#__PURE__*/_jsxs("div", {
        className: "display-flex m-right-auto p-top-4",
        children: [/*#__PURE__*/_jsx(UIPurchaseMotionButton, {
          className: "display-block m-x-auto",
          use: "link",
          level: 1,
          purchaseMotions: ['talkToSales'],
          upgradeData: UPGRADE_DATA,
          location: SCREENS.COMPARE_PROFESSIONAL,
          onClick: () => onCTAClick('clicked talk to sales button'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pricingCtas.talkToSales"
          })
        }), /*#__PURE__*/_jsx("span", {
          style: {
            color: 'darkgray'
          },
          className: "m-x-2",
          children: "|"
        }), /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
          className: "display-block m-x-auto",
          use: "link",
          level: 1,
          purchaseMotions: ['pricingPageRedirect'],
          upgradeData: UPGRADE_DATA,
          location: SCREENS.COMPARE_PROFESSIONAL,
          onClick: () => onCTAClick('clicked view pricing button'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "EBX642.viewPricing"
          })
        })]
      })]
    });
  };

  const SalesProCTAs = () => {
    return /*#__PURE__*/_jsxs(UIButtonWrapper, {
      className: "display-flex m-right-auto p-top-4",
      children: [/*#__PURE__*/_jsx(UIPurchaseMotionButton, {
        use: "primary",
        level: 1,
        purchaseMotions: ['pricingPageRedirect'],
        upgradeData: UPGRADE_DATA,
        location: SCREENS.COMPARE_PROFESSIONAL,
        onClick: () => onCTAClick('clicked view pricing button'),
        style: {
          width: '100%'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EBX642.viewPricing"
        })
      }), /*#__PURE__*/_jsx(UITrialActivationButton, {
        upgradeData: UPGRADE_DATA,
        block: true,
        use: "secondary",
        onClick: () => onCTAClick('clicked trial activation button')
      })]
    });
  };

  const CTAByProductLine = {
    [ProductLines.SALES]: SalesProCTAs(),
    [ProductLines.MARKETING]: MarketingProCTAs()
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(StyledCardWrapper, {
      children: [/*#__PURE__*/_jsx(UIMediaObject, {
        spacing: "extra-small",
        itemLeft: /*#__PURE__*/_jsx(UIIcon, {
          name: "upgrade",
          size: 24,
          color: LORAX
        }),
        children: /*#__PURE__*/_jsx(Title, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `EBX642.${productLineFormatted}.card.title`
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 300
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `merchCards.professionalCard.description.${productLineFormatted}`
        })
      }), /*#__PURE__*/_jsx(StyledBlob, {
        src: BLOB
      }), /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
        badgeStyle: {
          top: '12px',
          right: '12px'
        }
      }), /*#__PURE__*/_jsx("div", {
        style: {
          maxWidth: 400
        },
        children: CTAByProductLine[productLine]
      })]
    })
  });
};

export default EBX642CompareProCard;